import React, { useEffect, useState, } from 'react';
import { Link, } from 'react-router-dom';

import Swal from 'sweetalert2';
import axios from 'axios';
import $ from 'jquery';

import BuildingHeader from '../buildings/BuildingHeader';
import CoinsAddEditDetails from './CoinsAddEditDetails';
import { coinModelGet } from '../../models/coins/coin';

import useAuth from '../../controllers/users/useAuth';
import {
    dataTableLanguaje, responseGet, globalSettings, styles, sendMessageCloseCurrentWindowAsync, buttonProcessGet, processEvaluateGet, checkIfUserIsMaster, dateTimeFormatGlobalSet,
    separatorsNumbersSet, languageObjGet, isUndNullEmp, LoadingSection,
} from '../../helpers/settings';
import Menu from '../main/Menu';
import { buildingsByUserGetAsync } from '../../controllers/apartments/apartmentUsers';
import CoinRates from '../coinRates/CoinRates';
import { validationCountryGetAsync } from '../../helpers/validations';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { buildingModelGet } from '../../models/buildings/building';
import { coinRateModelGet } from '../../models/coinRates/coinRate';
import { countryModelGet } from '../../models/countries/country';

const currentMethod = 'Coins';

const { app, collections: dbColle, colors, icons, labels, messages, react, } = globalSettings;
const { backend, } = app;
const { properties: dbProps, } = dbColle;
const { operators: dbOpera, } = react?.firebase;
const { html: reactHtml, sweetAlert2, tempusDominus, } = react;

export default function Coins({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result = {};
    let dataObj = {};
    let headerObj = {};
    const auth = useAuth();
    let swalProperties = {};
    //const history = useHistory();
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
    const [showModal, setShowModal] = useState(false);
    const [dtCoinsRowIndexTwo, setDtCoinsRowIndexTwo] = useState(0);
    const [processType, setProcessType] = useState();

    const [countries, setCountries] = useState([]);
    const [showLoading, setShowLoading] = useState({ building: true, coins: true, });
    //const [showData, setShowData] = useState(false);
    const [btnAddDisable, setBtnAddDisable] = useState(true);
    //#endregion variables

    //#region buildings
    const buildingsId = 'buildings';
    const [building, setBuilding] = useState(buildingModelGet({}));
    const [buildings, setBuildings] = useState([buildingModelGet({})]);
    //#endregion buildings

    //#region coins
    let dtCoins = null;
    const dtCoinsId = 'dtCoins';
    const [coin, setCoin] = useState(coinModelGet({}));
    const [btnCoinsSyncDisabled, setBtnCoinsSyncDisabled] = useState(true);
    //#endregion coins

    //#region rates
    const [ratesDt, setRatesDt] = useState([]);
    const [rates, setRates] = useState([coinRateModelGet({})]);
    const [showModalRates, setShowModalRates] = useState(false);
    //#endregion rates

    //#region others
    const controls = {
        buttons: {
            // save: {
            //     id: 'btnCreate',
            //     className: 'btn btn-outline-warning mx-1',
            // },
            // back: {
            //     id: 'btnBack',
            //     className: '',
            // },
            // close: {
            //     id: 'btnClose',
            //     className: 'close btn-danger fas fa-window-close',
            // },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            coins: {
                buttons: {
                    add: {
                        className: 'btn btn-outline-success float-right btn-sm',
                        id: 'btndtCoinsIdAdd',
                    },
                    delete: {
                        className: 'btn btn-outline-danger float-right btn-sm mx-1',
                        id: 'btndtCoinsIdDelete',
                    },
                },
                icons: {
                    add: {
                        id: 'icondtCoinsIdAdd',
                        className: icons?.plusCircle,
                    },
                    delete: {
                        id: 'icondtCoinsIdDelete',
                        className: icons?.trash,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtCoinsId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtCoinsId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    add: {
                        id: 'spdtCoinsIdAdd',
                        className: '',
                    },
                    delete: {
                        id: 'spdtCoinsIdDelete',
                        className: '',
                    },
                },
            },
        },
        icons: {
            // save: {
            //     id: 'icoSave',
            //     className: icons?.save,
            // },
            // back: {
            //     id: 'icoBack',
            //     className: icons?.arrowCircleLeft,
            // },
            // close: {
            //     id: 'icoClose',
            //     className: icons?.plusCircle,
            // },
        },
        inputs: {
            // user: {
            //     id: 'inputUser',
            //     className: 'form-control bg-transparent',
            // },
            // title: {
            //     id: 'inputTitle',
            //     className: 'form-control bg-transparent',
            // },
            // comment: {
            //     id: 'inputComment',
            //     className: 'form-control',
            // },
            // statusComment: {
            //     id: 'inputStatusComment',
            //     className: 'form-control bg-transparent text-black',
            // },
        },
        selects: {
            // apartment: {
            //     id: 'selApartmet',
            //     className: 'form-select',
            // },
            // title: {
            //     id: 'selTitle',
            //     className: 'form-select',
            // },
            // icon: {
            //     id: 'selIcon',
            //     className: 'form-select',
            // },
            // status: {
            //     id: 'selStatus',
            //     className: 'form-select',
            // },
        },
        spinners: {
            // save: {
            //     id: 'spSave',
            //     className: '',
            // },
            // back: {
            //     id: 'spBack',
            //     className: '',
            // },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region coins (methods)
    const coinsGetAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'coinsGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            setShowLoading({ building: false, coins: true, });

            //#region variables
            let dtRows = [];
            let isEditLocal = false;
            let isDeleteLocal = false;
            let coinsLocal = [coinModelGet({})];
            let buildingLocal = buildingModelGet({});
            const buildingIdLocal = $(`#${buildingsId}`)?.val();
            //#endregion variables

            //#region initialize
            setBuilding({});
            setBtnAddDisable(true);
            setBtnCoinsSyncDisabled(true);
            $(`#${dtCoinsId}`)?.DataTable()?.rows()?.clear()?.draw(true);
            //#endregion initialize

            //#region coins get
            if (!isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                buildingLocal = buildings?.find(({ id }) => id === buildingIdLocal) || {};
                if (!isUndNullEmp({ data: buildingLocal?.id, subMethod: currentMethod, })?.result) {
                    headerObj = {
                        headers: {
                            authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                        },
                    };

                    dataObj = {
                        buildingId: buildingIdLocal,
                        limit: 0,
                        conditionals: [
                            { field: dbProps?.buildingId, operator: dbOpera?.equalTo, value: buildingIdLocal, }
                        ],
                        ordersBy: [
                            { field: dbProps?.description, value: 'asc', },
                        ],
                        languageId: languageObj?.id,
                        url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCoins}/`,
                    };

                    result = await axios?.post(
                        dataObj?.url,
                        dataObj,
                        headerObj,
                    );

                    response = result?.data || {};

                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoading({ building: false, coins: false, });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return response;
                    }

                    coinsLocal = response?.result || [];

                    if (!isUndNullEmp({ data: coinsLocal, subMethod: currentMethod, })?.result && coinsLocal?.length > 0) {
                        coinsLocal?.forEach((detail) => {
                            //#region processButtons set
                            dataObj = {
                                processButtons: [
                                    {
                                        isVisible: true,
                                        showDivider: true,
                                        isEnabled: true,
                                        methodName: backend?.methods?.showRates,
                                        icon: icons?.chartLine,
                                        label:
                                            labels?.rates?.[languageObj?.id],
                                    },
                                    {
                                        isVisible: true,
                                        showDivider: false,
                                        isEnabled: processEvaluateGet({
                                            object: detail,
                                            property: labels?.process?.en?.toLowerCase(),
                                            process: labels?.delete?.en?.toLowerCase(),
                                            subMethod: currentMethod,
                                        })?.result,
                                        methodName: backend?.methods?.delete,
                                        icon: icons?.trash,
                                        label: labels?.delete?.[languageObj?.id],
                                    },
                                ],
                            };
                            //#endregion processButtons set

                            //#region set coins data
                            dtRows.push([
                                detail.description,
                                detail.codeA,
                                detail.codeN,
                                buttonProcessGet({
                                    id: detail.id,
                                    description: detail.description,
                                    showDetails: true,
                                    labelDetails: labels?.detail?.[languageObj?.id],
                                    enabledDetails: processEvaluateGet({
                                        object: detail,
                                        property: labels?.process?.en?.toLowerCase(),
                                        process: labels?.detail.en.toLowerCase(),
                                        subMethod: currentMethod,
                                    })?.result,
                                    showEdit: true,
                                    labelEdit: labels?.edit?.[languageObj?.id],
                                    enabledEdit: processEvaluateGet({
                                        object: detail,
                                        property: labels?.process?.en?.toLowerCase(),
                                        process: labels?.edit?.en?.toLowerCase(),
                                        subMethod: currentMethod,
                                    })?.result,
                                    showDelete: false,
                                    labelDelete: '',
                                    enabledDelete: false,
                                    processButtons: dataObj?.processButtons,
                                    subMethod: currentMethod,
                                })?.result
                            ]);
                            //#endregion set coins data
                        });

                        //#region check if add register is enabled
                        isEditLocal = processEvaluateGet({
                            object: coinsLocal?.[0],
                            property: labels?.process?.en?.toLowerCase(),
                            process: labels?.edit?.en?.toLowerCase(),
                            subMethod: currentMethod,
                        })?.result;
                        isDeleteLocal = processEvaluateGet({
                            object: coinsLocal?.[0],
                            property: labels?.process?.en?.toLowerCase(),
                            process: labels?.edit?.en?.toLowerCase(),
                            subMethod: currentMethod,
                        })?.result;
                        //#endregion check if add register is enabled
                    }

                    //#region check if add register is enabled
                    isEditLocal = processEvaluateGet({
                        object: buildingLocal,
                        property: labels?.process?.en?.toLowerCase(),
                        process: labels?.edit?.en?.toLowerCase(),
                        subMethod: currentMethod,
                    })?.result;

                    isDeleteLocal = isEditLocal;
                    //#endregion check if add register is enabled
                }
                setBuilding(buildingLocal);
                setBtnCoinsSyncDisabled(false);
                setBtnAddDisable(!(isEditLocal && isDeleteLocal));
            }
            //#endregion coins get

            //#region load datatable
            $(`#${dtCoinsId}`)?.DataTable()?.rows?.add(dtRows)?.draw(true);
            //#endregion load datatable

            setShowLoading({ building: false, coins: false, });
        } catch (ex) {
            setShowLoading({ building: false, coins: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const coinAddGetAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'coinAddGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let coinLocal = coinModelGet({});
            let countriesLocal = [countryModelGet({})];
            const buildingIdLocal = $(`#${buildingsId}`)?.val();
            //#endregion variables

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region data get (countries)
            response = await validationCountryGetAsync({
                buildingId: '',
                auth: auth,
                limit: 0,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            countriesLocal = response?.result || [];
            setCountries(countriesLocal);
            //#endregion data get (countries)

            //#region data get (coin)
            coinLocal = coinModelGet({
                buildingId: buildingIdLocal,
                userId: auth?.user?.uid
            });

            setCoin(coinLocal);
            //#endregion coins get

            setProcessType(0);
            setShowModal(true);

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const coinEditDetailGetAsync = async ({
        id = '',
        description = '',
        rowIndex = 0,
        processType = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'coinEditDetailGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let coinLocal = coinModelGet({});
            let countriesLocal = [countryModelGet({})];
            //#endregion variables

            setShowLoading({ building: false, coins: true, });

            //#region countries get
            response = await validationCountryGetAsync({
                buildingId: '',
                auth: auth,
                limit: 0,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, coins: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            countriesLocal = response?.result || [];
            setCountries(countriesLocal);
            //#endregion contries get

            //#region data get (coin)
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCoins}/${id}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, coins: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            coinLocal = response?.result || {};
            //#endregion data get (coin)

            //#region controls data set
            setCoin(coinLocal);
            setProcessType(processType);
            setDtCoinsRowIndexTwo(rowIndex);
            //#endregion controls data set

            setShowModal(true);
            setShowLoading({ building: false, coins: false, });
        } catch (ex) {
            setShowLoading({ building: false, coins: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const coinDeleteAsync = async ({
        id = '',
        description = '',
        rowIndex = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'coinDeleteAsync';
        let response = responseGet();
        try {
            //#region show message
            let msgTextObj = {
                one: `${labels?.coin?.[languageObj?.id]}: <b>${description}</b><br/>`,
                two: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            swalProperties = {
                icon: sweetAlert2?.icons?.warning,
                title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: sweetAlert2?.icons?.info,
                            title: `${messages?.processing?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.one}`,
                            showConfirmButton: false,
                        });

                        //#region delete countr
                        headerObj = {
                            headers: {
                                languageId: languageObj?.id,
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                            },
                            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCoins}/${id}`
                        };

                        result = await axios.delete(
                            headerObj?.url,
                            headerObj,
                        );

                        response = result?.data || {};

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }
                        //#endregion delete country

                        //#region delete country (dataTable)
                        $(`#${dtCoinsId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);
                        //#endregion delete country (dataTable)

                        //#region data set
                        setCoin({});
                        setDtCoinsRowIndexTwo(0);
                        //#endregion data set

                        await sendMessageCloseCurrentWindowAsync({
                            msgType: 0,
                            msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            await Swal.fire(swalProperties);
            //#endregion show message   
        } catch (ex) {
            setShowLoading({ building: false, coins: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion coins (methods)

    //#region coin rates (nethods)
    const coinRatesShowAsync = async ({
        id = '',
        description = '',
        rowIndex = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'coinRatesShowAsync';
        let response = responseGet();
        try {
            //#region variables
            let dtRows = [];
            let coinLocal = coinModelGet({});
            let coinRates = [coinRateModelGet({})];
            const buildingIdLocal = $(`#${buildingsId}`)?.val();
            //#endregion variables

            setShowLoading({ building: false, coins: true, });

            //#region rates get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                buildingId: buildingIdLocal,
                coinId: id,
                languageId: languageObj?.id,
                limit: 0,
                ordersBy: [
                    { field: dbProps?.date, value: 'asc', },
                ],
                conditionals: [
                    { field: dbProps?.coinId, operator: dbOpera?.equalTo, value: id, },
                    { field: dbProps?.buildingId, operator: dbOpera?.equalTo, value: buildingIdLocal, },
                ],
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCoinRates}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, coins: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            coinLocal = response?.result?.coin || [];
            coinRates = response?.result?.rates || [];

            setCoin(coinLocal);
            setRates(coinRates);
            //#endregion data get (rates)

            //#region set ratesDt

            if (!isUndNullEmp({ data: coinRates, subMethod: currentMethod, })?.result && coinRates?.length > 0) {
                coinRates?.forEach((detail) => {
                    //#region variables
                    dataObj = {
                        dateTimeOrder: dateTimeFormatGlobalSet({
                            date: detail?.date,
                            type: tempusDominus?.format?.date?.ymdTwo,
                            format: 24,
                            addTime: false,
                            secondsShow: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result,
                        rate: separatorsNumbersSet({
                            number: detail?.rate,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                        dateTime: dateTimeFormatGlobalSet({
                            date: detail?.date,
                            type: languageObj?.format?.date?.f1,
                            format: languageObj?.format?.time?.type,
                            addTime: false,
                            secondsShow: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result,
                    };
                    //const rateLocal = separatorsNumbersSet(detail.rate, true).result;
                    //let dateTimeLocal = dateTimeFormatGlobalSet(detail.date, tempusDominus?.format?.date?.dmy, 12, false).result;
                    let msgTextLocal = `${labels?.date?.[languageObj?.id]}: <b>${dataObj?.dateTime}</b><br/>`;
                    msgTextLocal += `${labels?.rate?.[languageObj?.id]}: <b>${dataObj?.rate}</b>`;
                    //#endregion variables

                    //#region methods
                    dtRows.push([
                        //dateTimeFormatGlobalSet(detail.date, tempusDominus?.format?.date?.ymdTwo, 24, false).result,
                        //rateLocal,
                        //dateTimeFormatGlobalSet(detail.date, tempusDominus?.format?.date?.dmy, 12, false).result,
                        dataObj?.dateTimeOrder,
                        dataObj?.rate,
                        dataObj?.dateTime,
                        buttonProcessGet({
                            id: detail.id,
                            description: msgTextLocal,
                            showDetails: false,
                            labelDetails: '',
                            enabledDetails: false,
                            showEdit: true,
                            labelEdit: labels?.edit?.[languageObj?.id],
                            enabledEdit: processEvaluateGet({
                                object: detail,
                                property: labels?.process?.en?.toLowerCase(),
                                process: labels?.edit?.en?.toLowerCase(),
                                subMethod: currentMethod,
                            })?.result,
                            showDelete: true,
                            labelDelete: labels?.delete?.[languageObj?.id],
                            enabledDelete: processEvaluateGet({
                                object: detail,
                                property: labels?.process?.en?.toLowerCase(),
                                process: labels?.delete?.en?.toLowerCase(),
                                subMethod: currentMethod,
                            })?.result,
                            processButtons: [],
                            subMethod: currentMethod,
                        }).result,
                    ]);
                    //#endregion variables
                });
            }

            setRatesDt(dtRows);
            //#endregion set ratesDt

            setShowModalRates(true);
            setShowLoading({ building: false, coins: false, });
        } catch (ex) {
            setShowLoading({ building: false, coins: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion coin rates (nethods)

    //#region methods (others)
    const dataGetAsync = async ({
        subMethod = ''
    }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ building: true, coins: true, });

            //#region dataTable set
            response = dataTablesSet({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, coins: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion dataTable set

            //#region queryCode set
            response = queryCodeSet({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, coins: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion queryCode set

            //#region get data (buildings)
            response = await buildingsByUserGetAsync({
                userRole: userRole,
                auth: auth,
                urlGoTo: backend?.urlCoins,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, coins: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            if (!isUndNullEmp({ data: response?.result?.buildings, subMethod: currentMethod, })?.result && response?.result?.buildings?.length > 0) {
                setBuildings(response?.result?.buildings);
            }
            //#endregion get data (buildings)

            setShowLoading({ building: false, coins: false, });
        } catch (ex) {
            setShowLoading({ building: false, coins: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataTablesSet = ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataTablesSet';
        let response = responseGet();
        try {
            $(`#${dtCoinsId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.description?.[languageObj?.id], width: '65%', },
                    { title: labels?.codeA?.[languageObj?.id], width: '15%', },
                    { title: labels?.codeN?.[languageObj?.id], width: '15%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                order: [[0, 'asc']],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtCoinsId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const queryCodeSet = ({
        subMethod = '',
    }) => {
        const currentMethod = 'queryCodeSet';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            $(`#${dtCoinsId} tbody`)?.on('click', 'tr', 'td', async function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtCoinsId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'details':
                            coinEditDetailGetAsync({ id: id, description: description, rowIndex: dtRowIndex, processType: 2, subMethod: currentMethod, });
                            break;
                        case 'edit':
                            coinEditDetailGetAsync({ id: id, description: description, rowIndex: dtRowIndex, processType: 1, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            coinDeleteAsync({ id: id, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        case 'showRates':
                            coinRatesShowAsync({ id: id, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.dataTables?.coins?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.coins?.buttons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.coins?.spinners?.add?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.coins?.icons?.add?.id}`)?.addClass(controls?.dataTables?.coins?.icons?.add?.className);
                    $(`#${controls?.dataTables?.coins?.buttons?.add?.id}`)?.addClass(controls?.dataTables?.coins?.buttons?.add?.className);
                    $(`#${controls?.dataTables?.coins?.spinners?.add?.id}`)?.addClass(controls?.dataTables?.coins?.spinners?.add?.className);


                    $(`#${controls?.dataTables?.coins?.icons?.delete?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.coins?.buttons?.delete?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.coins?.spinners?.delete?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.coins?.icons?.delete?.id}`)?.addClass(controls?.dataTables?.coins?.icons?.delete?.className);
                    $(`#${controls?.dataTables?.coins?.buttons?.delete?.id}`)?.addClass(controls?.dataTables?.coins?.buttons?.delete?.className);
                    $(`#${controls?.dataTables?.coins?.spinners?.delete?.id}`)?.addClass(controls?.dataTables?.coins?.spinners?.delete?.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.create?.id}`)?.addClass(`${reactHtml?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.dataTables?.coins?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.coins?.spinners?.add?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region old code
            // $(`#${controls?.inputs?.email?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.password?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.checkBox?.remenberMe?.id}`).attr('disabled', (processType !== 0));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            $(`#${controls?.dataTables?.coins?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.coins?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                $(`#${controls?.dataTables?.coins?.buttons?.add?.id}`)?.addClass(`${reactHtml?.button?.classes?.disabled}`);
                $(`#${controls?.dataTables?.coins?.buttons?.delete?.id}`)?.addClass(`${reactHtml?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({
            subMethod: currentMethod,
        });
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion Methoods (others)

    return (
        <div>
            <Menu viewName='settings' process='coins' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.coins?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.coins?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {/*buildings*/}
                        <BuildingHeader
                            buildingsId={buildingsId}
                            building={building}
                            buildings={buildings}
                            btnSyncDisabled={btnCoinsSyncDisabled}
                            methodGetAsync={coinsGetAsync}
                            processType={0}
                            headerSectionValues={{}}
                            showLoading={showLoading?.building}
                            languageObj={languageObj} />

                        {/*coins*/}
                        <div className='row'>
                            <div className='col-12'>

                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={reactHtml?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.coins}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.coins?.[languageObj?.id]}
                                                style={styles?.cardHeaderLogo}
                                                src={globalSettings?.images?.coinsLogo}></img> - {labels?.coins?.[languageObj?.id]}
                                        </h6>
                                        {/* <div className='card-tools'> */}
                                        {/* </div> */}
                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div> {/*card header*/}

                                    <div className='card-body'>

                                        {/* <div className='dataTables_wrapper dt-bootstrap4'> */}
                                        <div className='row'>
                                            {/* {!showLoading ? */}
                                            <div className='col-md-12'>
                                                {/* {showData ? */}
                                                {/* <div> */}

                                                <button id={controls?.dataTables?.coins?.buttons?.add?.id}
                                                    className={controls?.dataTables?.coins?.buttons?.add?.className}
                                                    disabled={btnAddDisable}
                                                    tooltip='tooltip'
                                                    title={labels?.add?.[languageObj?.id]}
                                                    onClick={(e) => coinAddGetAsync({ e: e, subMethod: 'btn - coinAdd', })}>
                                                    <i id={controls?.dataTables?.coins?.icons?.add?.id} className={controls?.dataTables?.coins?.icons?.add?.className} /> <span id={controls?.dataTables?.coins?.spinners?.add?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtCoinsId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                </div>
                                                {/* </div> */}
                                                {/* : */}
                                                {/* <div></div> */}
                                                {/* } */}
                                            </div>
                                            {/* : */}
                                            {/* <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                                    width={40}
                                                    height={40}
                                                    color={globalSettings?.colors?.infoColorExp}
                                                    msgText={messages?.processing?.[languageObj?.id]}
                                                    msgOrientation='text-center'
                                                    msgTextMuted={true} /> */}
                                            {/* } */}
                                        </div>
                                        {/* </div> */}

                                    </div> {/*card body*/}

                                    <div className='card-footer'>

                                    </div> {/*card footer*/}

                                </div>{/*card*/}

                            </div>{/*col*/}
                        </div>

                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}

            </div>

            {showModal ?
                <CoinsAddEditDetails $={$}
                    auth={auth}
                    showModal={showModal}
                    setShowModal={setShowModal}
                    coin={coin}
                    setCoin={setCoin}
                    countries={countries}
                    dtId={dtCoinsId}
                    dtObj={dtCoins}
                    dtRowIndex={dtCoinsRowIndexTwo}
                    processType={processType}
                    languageObj={languageObj} />
                :
                <></>
            }

            {showModalRates ?
                <CoinRates $={$}
                    auth={auth}
                    coin={coin}
                    rates={rates}
                    setRates={setRates}
                    ratesDt={ratesDt}
                    showModal={showModalRates}
                    setShowModal={setShowModalRates}
                    languageObj={languageObj} />
                :
                <></>
            }
        </div>
    )
}